import {
  ADD_BULK_OPERATION,
  REMOVE_BULK_OPERATION,
  UPDATE_BULK_OPERATION_PROGRESS,
  CLEAR_BULK_OPERATIONS
} from '../actions/bulkOperationsActions';

import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

const initialState = {
  operations: [] // Array of bulk operations
};

export default function bulkOperationsReducer(state = initialState, action) {
  const { payload } = action;
  
  switch (action.type) {
    case ADD_BULK_OPERATION: {
      // Check if operation already exists to avoid duplicates
      const exists = state.operations.some(op => 
        op.teamUuid === payload.teamUuid && 
        op.workflowFileId === payload.workflowFileId
      );
      
      if (exists) {
        return state;
      }
      
      return {
        ...state,
        operations: [...state.operations, payload]
      };
    }

    case REMOVE_BULK_OPERATION: {
      return {
        ...state,
        operations: state.operations.filter(op => op.workflowFileId !== payload)
      };
    }

    case UPDATE_BULK_OPERATION_PROGRESS: {
      const { workflowFileId, progressData } = payload;
      
      return {
        ...state,
        operations: state.operations.map(op => {
          if (op.workflowFileId === workflowFileId) {
            return {
              ...op,
              ...progressData,
              status: progressData.status || op.status
            };
          }
          return op;
        })
      };
    }

    case CLEAR_BULK_OPERATIONS: {
      return {
        ...state,
        operations: []
      };
    }

    case RESET_ACCOUNT:
    case LOG_OUT: {
      return initialState;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/bulkOperationsReducer.js